import { motion } from "framer-motion";
import {
  backdropMotionProps,
  modalPopupMotionProps,
} from "../../Util/animations/Animations_v2";
import { useContext, useState } from "react";
import { AppContext } from "../../Util/contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPuzzle, faPuzzlePiece } from "@fortawesome/pro-solid-svg-icons";
import "./modalStyles.css";
import "./CompletionHistoryPopup.css";
import CompletionHistoryExam from "./CompletionHistoryExam";
import CompletionHistorySection from "./CompletionHistorySection";
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons";
import { createPortal } from "react-dom";
import ButtonListPopup from "../ButtonListPopup/ButtonListPopup";

const CompletionHistoryPopup = ({
  closePopup,
  previousCompletionsData,
  handleViewGrades,
  previousCompletionsPopupConfiguration,
  setPreviousCompletionsPopupConfiguration,
}) => {
  const [selectedCompletionIndex, setSelectedCompletionIndex] = useState(null);
  const [displaySectionsPopup, setDisplaySectionsPopup] = useState(false);
  const { userData, mousePosition } = useContext(AppContext);
  if (!userData) {
    return null;
  }
  const { AnimationsDisabled } = userData;

  const handleViewGradesClick = () => {
    if (previousCompletionsPopupConfiguration.type === "Sections") {
      handleViewGrades(
        previousCompletionsData.sections[
          previousCompletionsPopupConfiguration.sectionId
        ][selectedCompletionIndex].guid
      );
    } else {
      handleViewGrades(
        previousCompletionsData.exams[
          previousCompletionsPopupConfiguration.examId
        ][selectedCompletionIndex].guid
      );
    }
  };

  const handleViewExam = () => {
    const exam =
      previousCompletionsData.sections[
        previousCompletionsPopupConfiguration.sectionId
      ][selectedCompletionIndex].examForCompletion;
    console.log(exam);
    setPreviousCompletionsPopupConfiguration({
      type: "Exams",
      examId: exam.examId,
      title: exam.examTitle,
    });
  };

  const handleViewSections = () => {
    setDisplaySectionsPopup(true);
  };

  const handleSectionClick = (sectionId) => {
    setDisplaySectionsPopup(false);
    setPreviousCompletionsPopupConfiguration({
      type: "Sections",
      sectionId,
      title: `Section ${sectionId}`,
    });
  };

  const previouslyCompletedSections = previousCompletionsData.sections;
  const selectedSectionPreviousCompletions =
    previousCompletionsPopupConfiguration.type === "Sections"
      ? previouslyCompletedSections[
          previousCompletionsPopupConfiguration.sectionId
        ]?.sort((a, b) => new Date(b.date) - new Date(a.date)) || []
      : [];
  return (
    <div className="modalPageContainer">
      <motion.div
        className="modalBackdrop"
        onClick={closePopup}
        {...backdropMotionProps(AnimationsDisabled)}
        key="completionHistoryPopupBackdrop"
      />
      <motion.div
        className="modalContainer"
        {...modalPopupMotionProps(AnimationsDisabled)}
        key="completionHistoryPopupContainer"
      >
        <div className="modalHeaderWrapperWithIcon">
          <FontAwesomeIcon
            icon={
              previousCompletionsPopupConfiguration.type === "Sections"
                ? faPuzzlePiece
                : faPuzzle
            }
            className="modalHeaderIcon"
          />
          <h2>{previousCompletionsPopupConfiguration.title}</h2>
          <button className="popupCloseButton" onClick={closePopup} />
          <p>Select a previous completion to view your grades</p>
        </div>
        <div className="modalListContainer">
          {previousCompletionsPopupConfiguration.type === "Sections" &&
            selectedSectionPreviousCompletions.map((completionData, index) => (
              <CompletionHistorySection
                key={index}
                selectedCompletionIndex={selectedCompletionIndex}
                index={index}
                setSelectedCompletionIndex={setSelectedCompletionIndex}
                date={completionData.date}
                score={completionData.score}
                examName={completionData.examForCompletion.examTitle}
              />
            ))}
          {previousCompletionsPopupConfiguration.type === "Exams" &&
            previousCompletionsData.exams[
              previousCompletionsPopupConfiguration.examId
            ].map((completionData, index) => (
              <CompletionHistoryExam
                key={index}
                selectedCompletionIndex={selectedCompletionIndex}
                index={index}
                setSelectedCompletionIndex={setSelectedCompletionIndex}
                date={completionData.date}
                score={completionData.score}
                sections={completionData.sections}
              />
            ))}
        </div>
        <div className="modalTwoButtonsContainer">
          {previousCompletionsPopupConfiguration.type === "Sections" ? (
            <button
              className="modalSecondaryButton"
              disabled={selectedCompletionIndex === null}
              onClick={handleViewExam}
            >
              View Exam
            </button>
          ) : (
            <button
              className="modalSecondaryButton"
              onClick={handleViewSections}
            >
              <FontAwesomeIcon
                icon={faEllipsisVertical}
                style={{
                  marginRight: "8px",
                  fontSize: "16px",
                  position: "relative",
                  top: "1px",
                }}
              />
              View Sections
            </button>
          )}
          <button
            className="modalPrimaryButton"
            disabled={selectedCompletionIndex === null}
            onClick={handleViewGradesClick}
          >
            View Grade
          </button>
        </div>
      </motion.div>
      {displaySectionsPopup &&
        createPortal(
          <ButtonListPopup
            showButtonListPopup={displaySectionsPopup}
            setShowButtonListPopup={setDisplaySectionsPopup}
            mousePos={mousePosition}
            key={`sectionMoreOptionsPopup - ${previousCompletionsPopupConfiguration.examId}`}
            childKey={`sectionMoreOptionsPopupChild - ${previousCompletionsPopupConfiguration.examId}`}
            customContainerClass="completionHistorySectionPopupContainer"
          >
            {previousCompletionsData.exams[
              previousCompletionsPopupConfiguration.examId
            ][0].sections.map((section, index) => (
              <button
                key={index}
                className="completionHistorySectionPopupButton"
                onClick={() => handleSectionClick(section.sectionId)}
              >
                {`Section ${section.sectionId} - ${section.title}`}
              </button>
            ))}
          </ButtonListPopup>,
          document.body
        )}
    </div>
  );
};

export default CompletionHistoryPopup;
